import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackingService } from 'src/app/shared/services/tracking.service';

interface SeoData {
  themes: string[];
  attributes: SeoAttribute[];
}

interface SeoAttribute {
  name: string;
  values: (boolean | string)[];
}

@Component({
  selector: 'app-seo',
  templateUrl: './seo.component.html',
  styleUrls: ['./seo.component.scss'],
  animations: [
    trigger('slideFadeIn', [
      state('invisible', style({ opacity: 0, transform: 'translateY(20px)' })),
      state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('invisible => visible', animate('200ms {{delay}}ms ease-out')),
    ]),
  ],
})
export class SeoComponent implements AfterViewInit {
  @ViewChild('tableContainer', { static: true }) tableContainer!: ElementRef;
  animationState = 'invisible';
  trackingSent: boolean = false;
  entryTimer: any;

  seoData: SeoData = {
    themes: ['Phantom', 'Dawn', 'Speedfly', 'Fastlane'],
    attributes: [
      {
        name: this.translate.instant('home_seo.headers.hn'),
        values: [true, false, false, true],
      },
      {
        name: this.translate.instant('home_seo.headers.structured_data'),
        values: [true, true, true, true],
      },
      {
        name: this.translate.instant('home_seo.headers.no_index'),
        values: [true, false, false, false],
      },
      {
        name: this.translate.instant('home_seo.headers.internal_network'),
        values: [true, false, false, false],
      },
      {
        name: this.translate.instant('home_seo.headers.speed'),
        values: ['A', 'A', 'C', 'B'],
      },
      {
        name: this.translate.instant('home_seo.headers.support'),
        values: [true, true, true, true],
      },
    ],
  };

  constructor(
    private translate: TranslateService,
    private trackingService: TrackingService
  ) {}

  isString(value: any): boolean {
    return typeof value === 'string';
  }

  ngAfterViewInit() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!this.entryTimer && !this.trackingSent) {
              this.animationState = 'visible';
              this.entryTimer = setTimeout(() => {
                this.trackingService
                  .sendAppData({
                    event_name: 'SectionSEO',
                  })
                  .subscribe();

                this.trackingSent = true;
                clearTimeout(this.entryTimer);
                this.entryTimer = null;
              }, 15000);
            }
          } else {
            if (this.entryTimer) {
              clearTimeout(this.entryTimer);
              this.entryTimer = null;
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(this.tableContainer.nativeElement);
  }
}
